var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 16,
    viewBox: "0 0 36 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 1.06667C32.1 1.06667 33 2.02667 33 3.2V12.8C33 13.9733 32.1 14.9333 31 14.9333H3C1.9 14.9333 1 13.9733 1 12.8V3.2C1 2.02667 1.9 1.06667 3 1.06667H31ZM31 0H3C1.34 0 0 1.42933 0 3.2V12.8C0 14.5707 1.34 16 3 16H31C32.66 16 34 14.5707 34 12.8V3.2C34 1.42933 32.66 0 31 0Z",
    fill: "#91989E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.33424V10.6676H34V5.33424H35ZM36 4.26758H33V11.7342H36V4.26758Z",
    fill: "#91989E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13281V13.8661",
    stroke: "#F8D34D",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.13281V13.8661",
    stroke: "#F8D34D",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.13281V13.8661",
    stroke: "#F8D34D",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23 2.13281V13.8661",
    stroke: "#444F59",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29 2.13281V13.8661",
    stroke: "#444F59",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery4);
export default __webpack_public_path__ + "static/media/battery4.c357f879120e60816937f8810e3f0da9.svg";
export { ForwardRef as ReactComponent };